import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@app/pipes/translate.pipe';

@Component({
  selector: 'app-loader-modal',
  standalone: true,
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './loader-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader-modal.component.scss'],
})
export class LoaderModalComponent {
  @Input() message: string = 'GENERAL.LOADING.CREATING_TASK';
  @Input() showSpinner: boolean = true;
}
